import React from 'react';
import PropTypes from 'prop-types';
import { apColumn, isColumnOn, clsHeaderIcon, tableHeaderSortIdx } from '../helpers/TableHelpers';
import { isAdminDashboard } from 'utils/authScopes';

const simpleColumn = (idx, options, cls = '') => isColumnOn(idx, options) && <th className={cls}>{apColumn(idx)}</th>

const TABLE_HEADER = {
  0: 'id',
  4: 'players.birthday',
  5: 'dashboard_extended_players.creator_locale',
  6: 'players.created_at',
  7: 'dashboard_extended_players.last_app_touch',
  8: 'dashboard_extended_players.last_activity',
  9: 'players.plays_count',
  11: 'players.free_plays_count',
  13: 'players.scraps_count',
  15: 'dashboard_extended_players.cards_liked',
  16: 'dashboard_extended_players.cards_not_liked',
  17: 'dashboard_extended_players.cards_too_hard',
  18: 'dashboard_extended_players.cards_too_easy',
  19: 'dashboard_extended_players.cards_just_right',
  20: 'dashboard_extended_players.last_asq',
  21: 'dashboard_extended_players.last_message_from',
  22: 'dashboard_extended_players.last_message_to',
}

export default class AccountPlayersHeader extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.target.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(sort, newOrder);
  }

  sortedColumn(idx) {
    const { meta, options } = this.props;
    return isColumnOn(idx, options) && tableHeaderSortIdx(idx, meta, TABLE_HEADER, this.onSortChange);
  }

  render() {
    const { auth, meta, options } = this.props;
    return (
      <thead>
        <tr>
          { this.sortedColumn(0) }
          <th data-sort='players.name' onClick={this.onSortChange}>
            <span data-sort='players.name' className='o-table-header--sort'>
              Full Name<i data-sort='players.name' className={clsHeaderIcon('players.name', meta)}></i>
            </span>
          </th>
          { isAdminDashboard(auth) && <th>Partner</th> }
          { simpleColumn(1, options) }
          { simpleColumn(2, options) }
          { simpleColumn(3, options) }
          { this.sortedColumn(4) }
          { this.sortedColumn(5) }
          { this.sortedColumn(6) }
          { this.sortedColumn(7) }
          { this.sortedColumn(8) }
          { this.sortedColumn(9) }
          { meta.start && simpleColumn(10, options)}
          { this.sortedColumn(11) }
          { meta.start && simpleColumn(12, options)}
          { this.sortedColumn(13) }
          { meta.start && simpleColumn(14, options)}
          { this.sortedColumn(15) }
          { this.sortedColumn(16) }
          { this.sortedColumn(17) }
          { this.sortedColumn(18) }
          { this.sortedColumn(19) }
          { this.sortedColumn(20) }
          { this.sortedColumn(21) }
          { this.sortedColumn(22) }
        </tr>
      </thead>
    );
  }
}
